<template>
  <div class="form_step-2 form_step-gate form_step form-scroll">
    <form id="step-gate" @submit.prevent="submitForm" method="post">
      <div class="popup-title">{{__t('Бажаний спосіб надання даних')}}</div>

      <div class="delimiter-48"></div>

      <div class="button-group">
        <button type="submit" class="popup-button btn green-btn colored-btn">
          {{__t('Заповнити з менеджером')}}
        </button>
        <button type="button" class="popup-button btn red-btn" @click="goNext">
          {{__t('Заповнити самостійно')}}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

    export default {
        name: 'step-gate',

        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            
            goNext() {
                this.$emit('gonext');
                return false;
            },

            submitForm() {
              var self = this;
              self.$emit('openPreloader');
              var data = {
                  'landing_type': "cash"
              };
              jQuery.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                  data: data,
                  type: "POST",
                  url: '/cash/step-gate',
                  cache: false,
                  dataType: "json",
                  success: function (response) {
                      self.$emit('closePreloader');
                      if (response.status === "error" || response.status === "fatalError") {
                          self.handleError(response);
                          return;
                      }
                      self.$emit('exitForm');
                  },
                  error: function (error) {
                      console.log(error);
                      self.$emit('closePreloader');
                      self.handleError(response);
                  }
              });
            },

            handleError(data) {
              this.messageError = data.message;
              this.responseStatus = data.status;
            }
        },
    }

</script>
